const specialExceptionList = [
  "dominic.e.mahoney@gmail.com",
  "jamie.burke94@outlook.com",
  "shuler2097@gmail.com",
  "ahmed2gamal59@yahoo.com",
  "shuler@rapidx.bio",
  "Rhucha.Deshpande@southerntrust.hscni.net",
];

export default specialExceptionList;
